import { render, staticRenderFns } from "./Macro.vue?vue&type=template&id=3a32e5ff&scoped=true"
import script from "./Macro.vue?vue&type=script&lang=js"
export * from "./Macro.vue?vue&type=script&lang=js"
import style0 from "./Macro.vue?vue&type=style&index=0&id=3a32e5ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a32e5ff",
  null
  
)

export default component.exports